import { render, staticRenderFns } from "./LeftSideWideCardNew.vue?vue&type=template&id=42ffdb8b"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42ffdb8b')) {
      api.createRecord('42ffdb8b', component.options)
    } else {
      api.reload('42ffdb8b', component.options)
    }
    module.hot.accept("./LeftSideWideCardNew.vue?vue&type=template&id=42ffdb8b", function () {
      api.rerender('42ffdb8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LeftSideWideCardNew.vue"
export default component.exports